/**
 * Обработчик выбора кнопки в группе кнопок управления TreeView.
 */

function selectButtonAggregationTreeView_onSelect({ sender, indices: [selectedLink] }: kendo.ui.ButtonGroupSelectEvent) {
    const actionMap = {
        collapseFirstLevel: 0,
        collapseAll: 1,
        expandFirstLevel: 2,
        expandAll: 3
    };

    const treeViewId: string = sender.element.data('for-tree-view') || document.querySelector('.k-treeview')?.id;
    const treeViewInstance = window[treeViewId];

    if (treeViewInstance instanceof kendo.ui.TreeView) {
        switch (selectedLink) {
            case actionMap.collapseFirstLevel:
                expandCollapseButtonsTreeView_btCollapseFirstLevel_onClick(treeViewInstance);
                break;
            case actionMap.collapseAll:
                expandCollapseButtonsTreeView_btCollapse_onClick(treeViewInstance);
                break;
            case actionMap.expandFirstLevel:
                expandCollapseButtonsTreeView_btExpandFirstLevel_onClick(treeViewInstance);
                break;
            case actionMap.expandAll:
                expandCollapseButtonsTreeView_btExpand_onClick(treeViewInstance);
        }
    }
}

/**
 * Раскрыть все свернутые узлы TreeView.
 */
function expandCollapseButtonsTreeView_btExpand_onClick(treeView: kendo.ui.TreeView) {
    treeView.expand('.k-treeview-item');
}

/**
 * Свернуть все раскрытые узлы TreeView.
 */
function expandCollapseButtonsTreeView_btCollapse_onClick(treeView: kendo.ui.TreeView) {
    treeView.collapse('.k-treeview-item');
}

/**
 * Группирует uid узлов с потомками по уровню вложенности.
 * @param items — элементы dataSource текущего уровня.
 * @param level — текущая глубина.
 * @param expandedOnly — true: собирать раскрытые, false: свёрнутые.
 * @param result — карта: уровень → массив uid.
 */
function collectNodesByLevel(
    items: kendo.data.ObservableArray | kendo.data.HierarchicalDataSource,
    level: number,
    expandedOnly: boolean,
    result: Map<number, string[]>
) {
    const itemsArray = Array.isArray(items) ? items : Array.from(items as unknown as Iterable<kendo.data.ObservableObject>);

    for (const item of itemsArray) {
        if (!item.hasChildren) {
            continue;
        }

        if (expandedOnly === Boolean(item.expanded)) {
            if (!result.has(level)) {
                result.set(level, []);
            }
            result.get(level)?.push(item.uid);
        }

        if (item.children) {
            const childrenData = item.children.data ? item.children.data() : item.children;
            collectNodesByLevel(childrenData, level + 1, expandedOnly, result);
        }
    }
}

/**
 * Находит DOM-узлы по uid и применяет действие (expand/collapse).
 * @param treeView — экземпляр TreeView.
 * @param uids — массив uid узлов.
 * @param action — метод expand или collapse.
 */
function applyToNodes(
    treeView: kendo.ui.TreeView,
    uids: string[] = [],
    action: (nodes: JQuery) => void
) {
    if (uids.length) {
        const nodes = uids
            .map((uid) => treeView.findByUid(uid)?.get(0))
            .filter(Boolean);

        nodes.length && action.call(treeView, $(nodes));
    }
}

/**
 * Раскрывает первый уровень, где ещё есть свёрнутые узлы.
 */
function expandCollapseButtonsTreeView_btExpandFirstLevel_onClick(treeView: kendo.ui.TreeView) {
    const levelMap = new Map<number, string[]>();
    collectNodesByLevel(treeView.dataSource.data(), 0, false, levelMap);

    if (levelMap.size) {
        const minLevel = Math.min(...levelMap.keys());
        applyToNodes(treeView, levelMap.get(minLevel), treeView.expand);
    }
}

/**
 * Сворачивает самый глубокий раскрытый уровень.
 */
function expandCollapseButtonsTreeView_btCollapseFirstLevel_onClick(treeView: kendo.ui.TreeView) {
    const levelMap = new Map<number, string[]>();
    collectNodesByLevel(treeView.dataSource.data(), 0, true, levelMap);

    if (levelMap.size) {
        const maxLevel = Math.max(...levelMap.keys());
        applyToNodes(treeView, levelMap.get(maxLevel), treeView.collapse);
    }
}

window.selectButtonAggregationTreeView_onSelect = selectButtonAggregationTreeView_onSelect;
window.expandCollapseButtonsTreeView_btExpand_onClick = expandCollapseButtonsTreeView_btExpand_onClick;
window.expandCollapseButtonsTreeView_btCollapse_onClick = expandCollapseButtonsTreeView_btCollapse_onClick;
window.expandCollapseButtonsTreeView_btExpandFirstLevel_onClick = expandCollapseButtonsTreeView_btExpandFirstLevel_onClick;
window.expandCollapseButtonsTreeView_btCollapseFirstLevel_onClick = expandCollapseButtonsTreeView_btCollapseFirstLevel_onClick;

